
import { defineComponent, reactive, ref, toRefs } from "vue";
import BaseFormFieldInput from "../components/BaseFormFieldInput.vue";
import InputFieldFeedbackStatus from "../enum/InputFieldFeedbackStatus.enum";
import BaseFormConfig from "../interfaces/config/BaseFormConfig.interface";
import Section from "../interfaces/Section/Section.interface";
import RoomForm from "../interfaces/Room/RoomForm.interface";
import BackButton from "./BackButton.vue";
export default defineComponent({
  name: "CreateRoom",
  components: { BaseFormFieldInput, BackButton },
  props: {
    config: {
      required: true,
      type: Object as () => BaseFormConfig,
    },
    baseRoom: {
      required: false,
      type: Object as () => RoomForm,
    },
  },
  setup(props) {
    const sectionInput = ref("");
    const roomCodeInputError = ref("Enter a room code");
    const registerInformation = reactive(
      //Need object assign to create a new object, to hinder mutating a prop
      Object.assign(
        {},
        //Either uses the base room sent from the props or a default base room
        props.baseRoom ?? {
          roomCode: "",
          sections: [],
        }
      )
    );

    const roomCodeStatus = ref(InputFieldFeedbackStatus.NONE);
    const checkRoomCodeValidity = () => {
      if (registerInformation.roomCode.trim() === "") {
        roomCodeInputError.value = "Enter a room code";
        roomCodeStatus.value = InputFieldFeedbackStatus.ERROR;
      } else if (
        !/^[A-Za-z0-9-_æøåÆØÅ]{4,}$/i.test(registerInformation.roomCode.trim())
      ) {
        roomCodeInputError.value =
          "Syntax error: Use only alphabet, numbers, -, _, no spaces and length must be greater than 3";
        roomCodeStatus.value = InputFieldFeedbackStatus.ERROR;
      } else roomCodeStatus.value = InputFieldFeedbackStatus.SUCCESS;
    };

    const sectionsStatus = ref(InputFieldFeedbackStatus.NONE);
    const checkSectionsValidity = () => {
      sectionsStatus.value =
        registerInformation.sections.length !== 0
          ? InputFieldFeedbackStatus.SUCCESS
          : InputFieldFeedbackStatus.ERROR;
    };

    const addSectionHandler = () => {
      if (sectionInput.value.trim() === "") return;
      if (
        registerInformation.sections.filter(
          (section) => section.sectionName === sectionInput.value
        ).length > 0
      )
        return;

      registerInformation.sections.unshift({
        sectionName: sectionInput.value,
      } as Section);
      checkSectionsValidity();
    };

    const removeSectionHandler = (index: number) => {
      registerInformation.sections.splice(index - 1, 1);
      checkSectionsValidity();
    };

    const checks = ref([checkRoomCodeValidity, checkSectionsValidity]);

    const statuses = ref([roomCodeStatus, sectionsStatus]);

    return {
      roomCodeInputError,
      sectionInput,
      registerInformation,
      roomCodeStatus,
      checkRoomCodeValidity,
      sectionsStatus,
      checkSectionsValidity,
      addSectionHandler,
      removeSectionHandler,
      ...toRefs(registerInformation),
      statuses,
      checks,
    };
  },
});
